import { useState } from 'react';
import { LayoutHelper } from '@ers/helpers';

const useMenuState = () => {
    const animationDuration = 200;
    const states = {
        closed: '--menu-closed',
        opening: '--menu-opening',
        opened: '--menu-opened',
        closing: '--menu-closing'
    };
    const cycle = [states.closed, states.opening, states.opened, states.closing];
    // const [index, setIndex] = useState(0);
    const [current, setCurrent] = useState(cycle[0]);
    const changeState = (i) => {
        let newIndex = (i + 1) % cycle.length;
        // setIndex(newIndex);
        setCurrent(cycle[newIndex]);
        const timeout = setTimeout(() => {
            newIndex = (newIndex + 1) % cycle.length;
            // setIndex(newIndex);
            setCurrent(cycle[newIndex]);
            if (newIndex) {
                LayoutHelper.lockScroll();
            } else {
                LayoutHelper.unlockScroll();
            }
            clearTimeout(timeout);
        }, animationDuration);
    };
    const open = () => changeState(0);
    const close = () => changeState(2);

    return { state: current, opened: current === states.opened, open, close };
};
export default useMenuState;
